import { useEffect } from 'react';

import { selectErrorCode } from 'util/selector/axiosSelector';

import { datadogLogs } from '@datadog/browser-logs';
import { getAppConfig } from 'app/getConfig';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'config/featureFlags';
import { AxiosError } from 'axios';
import { latestReduxActions, wrappedReduxStateSnapshot } from 'shared/constants';

export const useInitializeDataDogLogs = () => {
  const isRUMEnabled = useFeatureIsOn(FeatureFlags.DATADOG_LOGS);
  const { DATADOG_ADMIN_UI_CLIENT_TOKEN, NODE_ENV } = getAppConfig();

  const isAllowedToInit = isRUMEnabled && DATADOG_ADMIN_UI_CLIENT_TOKEN;

  useEffect(() => {
    if (isAllowedToInit) {
      datadogLogs.init({
        clientToken: DATADOG_ADMIN_UI_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'admin-ui',
        env: NODE_ENV,
        sessionSampleRate: 100,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: 'all',
      });
    } else {
      datadogLogs.logger.error('datadogLogs failed to init', {
        env: NODE_ENV,
        service: 'admin-ui',
        DATADOG_ADMIN_UI_CLIENT_TOKEN: !!DATADOG_ADMIN_UI_CLIENT_TOKEN,
        isRUMEnabled,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const logInterceptedError = (error: AxiosError) => {
  const errorCode = selectErrorCode(error);

  datadogLogs.logger.error(`[Axios] ${errorCode} Error Intercepted`, {
    latestReduxActions: [...latestReduxActions].reverse(),
    error,
    state: wrappedReduxStateSnapshot.state,
  });
};
